export default __webpack_public_path__ + "static/media/chart-line-solid.92f1eca6.svg";